import Vue from 'vue';
import __vue_component__$1 from './TabItem.vue.js';
import __vue_component__ from '../icons/Icon.vue.js';

/**
 * @deprecated Use SdsTypeSwitcher instead
 */
var script = Vue.extend({
    name: 'TypeSwitcher',
    props: {
        types: {
            type: Array,
            required: true,
        },
        selected: {
            type: [String, Number],
            required: false,
            default: null,
        },
    },
    methods: {
        onClick: function (item) {
            if (item.disabled) {
                return;
            }
            this.$emit('click', item.type);
        },
    },
    components: {
        Icon: __vue_component__,
        TabItem: __vue_component__$1,
    },
});

export default script;
